try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

require('bootstrap/js/src/modal');
window.axios = require('axios');
import Cookies from 'js-cookie';

$(document).ready(() => {
    const cookieBar = $('.cookies-bar');

    if( ! Cookies.get( 'rt_cookies' ) ) {
        cookieBar.removeClass('inactive');
        cookieBar.animate({
            'bottom': 0
        }, 500, 'linear');
    }

    // Cookies function
    $('.cookies-bar #accept-cookie').click(function(e) {

        e.preventDefault();

        Cookies.set( 'rt_cookies', 1, { expires: 30 });

        cookieBar.animate({
            'bottom': -50
        }, 500, 'linear', function() {
            cookieBar.addClass('inactive');
        });

    });

    $('form button').click((e) => {
        e.preventDefault();
        let data = {
            name: $('input#name').val(),
            email: $('input#email').val(),
            message: $('textarea#message').val()
        }

        $('form').addClass('d-none');
        $('.response-loading').removeClass('d-none');

        axios.post( location.origin + '/app/includes/sendmail.php', data )
            .then((response) => {
                let outcome = response.data;
                $('.response-loading').addClass('d-none');

                if( response.data.sended ) {
                    $('.response-positive').removeClass('d-none');
                } else {
                    $('.response-negative').removeClass('d-none');
                }

            })
            .catch((error) => {
                $('form').removeClass('d-none');
                $('.response-loading').addClass('d-none');
                let errors = error.response.data.errors;
                $('input, textarea').each(function(i) {
                    if( errors.hasOwnProperty( $(this).attr('id') ) ) {
                        $(this).addClass('is-invalid');
                        $(this).parent('.form-group').find('.invalid-feedback').text( errors[$(this).attr('id')] )
                    }
                })
            })
    });

    $('input, textarea').on('keydown', (e) => {
        $(e.currentTarget).removeClass('is-invalid');
        $(e.currentTarget).parent('.form-group').find('.invalid-feedback').empty();
    });
});